/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var GetAllBondCompanies = require('../services/GetAllBondCompanies');
var GetLicenseContactTypes = require('../services/GetLicenseContactTypes');
var GetSalesFinanceApplication = require('../services/GetSalesFinanceApplication');
var GetLicenseContactTypesByApplicationType = require('../services/GetLicenseContactTypesByApplicationType');
var GetLicenseContactsAndOfficersByEntity = require('../../common/services/GetLicenseContactsAndOfficersByEntity');
var GetApplicationDBAs = require('../services/GetApplicationDBAs');

var SalesFinanceLicenseApplication = require('../forms/SalesFinanceLicenseApplication');

module.exports = {
  event: 'build:license-new:sales-finance',

  channel: 'nd:application',

  builder: function(config) {
    var defer = $.Deferred();
    $.when(
      GetAllBondCompanies(),
      GetLicenseContactTypes(),
      GetSalesFinanceApplication(config.applicationId),
      GetLicenseContactTypesByApplicationType(config.applicationTypeId),
      GetLicenseContactsAndOfficersByEntity(config.entityId),
      GetApplicationDBAs(config.applicationId)
    ).done(function(bondCompanies, licenseContactTypes, applicationContent, requiredLicenseContactTypes, existingContacts, dbas) {
      var consumerDiscountApplicationView = new SalesFinanceLicenseApplication({
        isReadOnly: config.isReadOnly,
        mode: config.mode || 'new', // new, resubmit, print or int-expand
        identoGoLink: config.identoGoLink,
        model: new Backbone.Model({
          bondCompanies: bondCompanies,
          licenseContactTypes: licenseContactTypes,
          applicationContent: applicationContent,
          requiredLicenseContactTypes: requiredLicenseContactTypes,
          existingContacts: existingContacts,
          entityDBAs: dbas.entityDBAs,
          applicationDBAs: dbas.appDBAs
        })
      });
      defer.resolve(consumerDiscountApplicationView);
    });
    return defer.promise();
  }
};
